export default __webpack_public_path__ + "static/media/cunningstrike4.2ee566cd.png";